<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-card-title class="elevation-0">
          <span class="itemHeading">Add PMR</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card elevation="0">
          <v-form ref="pmrForm">
            <v-layout wrap>
              <v-flex xs12 sm6 align-self-center text-left pa-2>
                <v-autocomplete
                  v-model="employee"
                  :items="employeeItems"
                  :search-input.sync="employeeSearch"
                  :loading="employeeLoading"
                  item-text="label"
                  item-value="_id"
                  no-filter
                  outlined
                  dense
                  hide-details
                  label="Employee"
                  placeholder="Search by name or employee ID"
                  clearable
                  :menu-props="{ maxHeight: 300 }"
                >
                  <template v-slot:no-data>
                    <div class="pa-3 text-center caption">
                      {{ employeeLoading ? "Loading..." : "No employees found" }}
                    </div>
                  </template>
                  <template v-slot:append-item>
                    <div
                      v-if="hasMoreEmployees"
                      v-intersect="onEmployeeListEnd"
                      class="text-center pa-2"
                    >
                      <v-progress-circular
                        indeterminate
                        color="success"
                        size="20"
                      ></v-progress-circular>
                    </div>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2>
                <v-select
                  v-model="fyear"
                  :items="financialYears"
                  outlined
                  dense
                  hide-details
                  label="Financial Year"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 md4 align-self-center text-left pa-2>
                <v-text-field
                  v-model="quantitativeScore"
                  :label="`Section A - Quantitative Assessment (max ${max.quantitative})`"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :max="max.quantitative"
                  step="0.5"
                  @wheel="$event.target.blur()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 align-self-center text-left pa-2>
                <v-text-field
                  v-model="qualitativeScore"
                  :label="`Section B - Qualitative Assessment (max ${max.qualitative})`"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :max="max.qualitative"
                  step="0.5"
                  @wheel="$event.target.blur()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4 align-self-center text-left pa-2>
                <v-text-field
                  v-model="piRating"
                  :label="`Section C - PI Rating (max ${max.pi})`"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :max="max.pi"
                  step="0.5"
                  @wheel="$event.target.blur()"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 align-self-center text-left pa-2>
                <v-text-field
                  :value="totalScore"
                  :label="`Total Score (max ${max.total})`"
                  outlined
                  dense
                  hide-details
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 align-self-center text-left pa-2>
                <v-text-field
                  v-model="rating"
                  :label="`PMR Rating (max ${max.rating})`"
                  outlined
                  dense
                  hide-details
                  type="number"
                  min="0"
                  :max="max.rating"
                  step="0.5"
                  @wheel="$event.target.blur()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 align-self-center text-left pa-2>
                <v-textarea
                  v-model="reviewerComments"
                  label="Reviewer's Additional Comments"
                  outlined
                  dense
                  hide-details
                  rows="4"
                  auto-grow
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 align-self-center text-center pa-2>
                <v-layout wrap justify-center py-4>
                  <v-flex xs12 sm6 md4 lg3 align-self-center px-4>
                    <v-btn
                      color="#005f32"
                      dark
                      tile
                      large
                      class="rounded-xl"
                      block
                      @click="validateInput()"
                    >
                      Submit
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import Intersect from "vuetify/lib/directives/intersect";
export default {
  directives: { Intersect },
  data() {
    return {
      showsnackbar: false,
      msg: null,
      appLoading: false,
      max: { quantitative: 60, qualitative: 20, pi: 20, total: 100, rating: 10 },
      financialYears: [],
      employeeList: [],
      employee: null,
      selectedEmployee: null,
      employeeSearch: null,
      searchTimer: null,
      requestId: 0,
      fyear: null,
      quantitativeScore: null,
      qualitativeScore: null,
      piRating: null,
      rating: null,
      reviewerComments: "",
      // Pagination for employee dropdown
      currentPage: 1,
      totalEmployees: 0,
      hasMoreEmployees: true,
      employeeLoading: false,
    };
  },
  computed: {
    employeeItems() {
      const items = this.employeeList.map((e) => ({
        _id: e._id,
        label: this.employeeLabel(e),
      }));
      // Keep the chosen employee in the list while a search narrows it down
      const sel = this.selectedEmployee;
      if (sel && !items.some((i) => i._id === sel._id)) {
        items.unshift({ _id: sel._id, label: this.employeeLabel(sel) });
      }
      return items;
    },
    totalScore() {
      const parts = [this.quantitativeScore, this.qualitativeScore, this.piRating];
      if (parts.every((p) => p === null || p === "")) return "";
      const sum = parts.reduce((acc, p) => acc + (Number(p) || 0), 0);
      return Math.round(sum * 100) / 100;
    },
  },
  watch: {
    employee(id) {
      this.selectedEmployee = id ? this.employeeList.find((e) => e._id === id) || this.selectedEmployee : null;
    },
    employeeSearch(text) {
      // Picking an item fills the search box with its label - no need to search again
      if (this.selectedEmployee && text === this.employeeLabel(this.selectedEmployee)) return;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.getEmployeeList(1, false), 300);
    },
  },
  mounted() {
    this.generateFinancialYears();
    this.getEmployeeList();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  methods: {
    employeeLabel(e) {
      return e.employeeId ? `${e.name} (${e.employeeId})` : e.name;
    },
    showMsg(text) {
      this.msg = text;
      this.showsnackbar = true;
    },
    generateFinancialYears() {
      const now = new Date();
      // Financial year runs April - March
      const currentStart = now.getMonth() < 3 ? now.getFullYear() - 1 : now.getFullYear();
      const years = [];
      for (let y = currentStart + 1; y >= 2000; y--) {
        years.push(`${y}-${y + 1}`);
      }
      this.financialYears = years;
      this.fyear = `${currentStart}-${currentStart + 1}`;
    },
    // Returns an error message when the value is not a number in [0, max], otherwise null
    checkScore(value, max, label) {
      if (value === null || value === "" || value === undefined) {
        return `Please provide ${label}`;
      }
      const n = Number(value);
      if (!Number.isFinite(n) || n < 0 || n > max) {
        return `${label} must be between 0 and ${max}`;
      }
      return null;
    },
    validateInput() {
      if (!this.employee) return this.showMsg("Please select an employee");
      if (!this.fyear) return this.showMsg("Please select a financial year");
      const error =
        this.checkScore(this.quantitativeScore, this.max.quantitative, "Quantitative Assessment score") ||
        this.checkScore(this.qualitativeScore, this.max.qualitative, "Qualitative Assessment score") ||
        this.checkScore(this.piRating, this.max.pi, "PI Rating") ||
        this.checkScore(this.rating, this.max.rating, "PMR Rating");
      if (error) return this.showMsg(error);
      if (Number(this.rating) === 0) return this.showMsg("PMR Rating must be greater than 0");
      this.addpmr();
    },
    addpmr() {
      this.appLoading = true;
      axios({
        url: "pmrscore/add",
        method: "POST",
        data: {
          employeeId: this.employee,
          fyear: this.fyear,
          quantitativeScore: this.quantitativeScore,
          qualitativeScore: this.qualitativeScore,
          piRating: this.piRating,
          rating: this.rating,
          reviewerComments: this.reviewerComments,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.showMsg(response.data.msg);
          if (response.data.status) {
            this.$router.push("/PMR/viewPMR");
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.showMsg("Something went wrong!");
          console.log(err);
        });
    },
    getEmployeeList(page = 1, append = false) {
      this.employeeLoading = true;
      // Only the latest request may update the list (a slow earlier search must not overwrite it)
      const requestId = ++this.requestId;
      const keyword = (this.employeeSearch || "").trim();

      axios({
        url: "/employees/getalllist",
        method: "GET",
        params: {
          id: this.$route.query.id,
          // the server treats keyword as a regular expression
          keyword: keyword ? keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") : undefined,
          page: page,
          limit: 50,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (requestId !== this.requestId) return;
          this.employeeLoading = false;

          if (response.data.status) {
            const newData = response.data.data;

            if (append) {
              this.employeeList = [...this.employeeList, ...newData];
            } else {
              this.employeeList = newData;
            }

            this.currentPage = response.data.page || page;
            this.totalEmployees = response.data.length || 0;
            this.hasMoreEmployees = this.employeeList.length < this.totalEmployees;
          }
        })
        .catch((err) => {
          if (requestId !== this.requestId) return;
          this.employeeLoading = false;
          console.log(err);
        });
    },
    // Fired when the loader at the bottom of the dropdown scrolls into view
    onEmployeeListEnd(entries, observer, isIntersecting) {
      if (isIntersecting && this.hasMoreEmployees && !this.employeeLoading) {
        this.getEmployeeList(this.currentPage + 1, true);
      }
    },
  },
};
</script>
